export default __webpack_public_path__ + "static/media/congrats.5fd7f1e5.svg";